import { css } from '@emotion/css';

export const paddingRightClass = css({
  paddingRight: '4px',
});
